import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { appConstantSettings } from 'srcReact/appConstantSettings'
import MainContainer from './components/MainContainer'
import RightContainer from './components/RightContainer'
import { urlSearchParams } from 'srcReact/helpers/utils'
import { profileActions } from './action'
import styles from './styles.module.scss'
import { organizationActions } from 'srcReact/OrganizationPage'
import { rightsExit } from 'srcReact/helpers/userHelper'
import PageContainer from 'srcReact/PageContainer/PageContainer'
import { alertActions, AlertContainer } from 'srcReact/Alert'
import { commonActions } from 'srcReact/components'
import { checkNested, isEmpty } from 'srcReact/helpers/validator'
import Loader from 'srcReact/components/common2/Loader'
import { getCurrentOrgId } from 'srcReact/helpers/organizationHelper'

export default function MyProfile(props) {
  const { t } = useTranslation()
  const dispatch = useDispatch()

  const {
    alert,
    myProfile: { userStatus, profileData, pictureUpdating }
  } = useSelector((state) => state)

  const {
    login: { loggedIn, user },
    common: { isNative, isDesktop },
    organization: { current_organization }
  } = useSelector((state) => state)
  useEffect(() => {
    const userId = props.match.params.userId ? props.match.params.userId : user.id
    if (userId) {
      dispatch(commonActions.addUserPageView(appConstantSettings.PROFILE_PAGE, userId))
    }
    return () => {
      dispatch(profileActions.clearData())
    }
  }, [])
  useEffect(() => {
    if (loggedIn && checkNested(current_organization, 'info', 'id') && !rightsExit(current_organization)) {
      dispatch(organizationActions.getOrganizationInfo(current_organization.info.id))
    }
  }, [])

  useEffect(() => {
    const orgId = getCurrentOrgId()
    dispatch(
      profileActions.getProfileDetails({
        organization_id: orgId,
        user_id: props.match.params.userId
      })
    )
  }, [props.match.params.userId])

  return (
    <PageContainer
      pageTitle={t('my_profile.title')}
      pageClassName={`${styles.profileContainer} ${profileData?.loading && styles.profileContainerLoader} ${
        isNative && styles.nativeProfileContainer
      }`}
      withFooter={false}
      withSidebar={true}>
      {alert && alert.message ? (
        <AlertContainer
          title={t('error.error_alert_title')}
          message={alert.message}
          show={!!alert.message}
          handleClose={() => dispatch(alertActions.clear())}
        />
      ) : null}
      {(profileData?.loading && !pictureUpdating) || isEmpty(profileData?.user?.id) ? (
        <Loader className={styles.loader} />
      ) : (
        <React.Fragment>
          <MainContainer />
          {userStatus === 'deleted' || userStatus === 'deactivated' ? '' : isDesktop ? <RightContainer /> : ''}
        </React.Fragment>
      )}
    </PageContainer>
  )
}
